//angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//app
import { AuthGuardService } from '../../_guard/auth.guard';
import { LayoutLoginComponent } from './layout/layout.component';
import { ForgotComponent } from './forgot/forgot.component';
import { SignInComponent } from './signin/signin.component';
import { SignUpComponent } from './signup/signup.component';
import { SwitchComponent } from './switch/switch.component';
import { VerifyComponent } from './verify/verify.component';
import { LoggedInGuard } from 'src/app/_guard/loggedin.guard';

const LoginRoutes: Routes = [
    {
        path: '',
        component: LayoutLoginComponent,
        pathMatch: 'prefix',
        children: [
            {
                path: '',
                redirectTo: 'signin',
                pathMatch: 'full'
            },
            {
                path: 'forgot',
                component: ForgotComponent
            },
            {
                path: 'signin',
                canActivate: [LoggedInGuard],
                component: SignInComponent
            },
            {
                path: 'signup',
                component: SignUpComponent
            },
            {
                path: 'signup/:id',
                component: SignUpComponent
            },
        ]
    },
    {
        path: 'switch',
        component: SwitchComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'verify',
        component: VerifyComponent,
        canActivate: [AuthGuardService]
    }
];

@NgModule({
    exports: [
        RouterModule
    ],
    imports: [
        RouterModule.forChild(LoginRoutes)
    ]
})

export class LoginRoutingModule { }
